import { createContext, useState, useEffect } from 'react'
import axios from 'axios'

import { urlValue } from './url'
import { unfolder } from './CryptoMethods'
import { getCookie } from './CookiesMethod'
import { fileSecurity } from './security/fileSecurity'

export const validContext = createContext(null)

// Flag para evitar múltiples redirecciones simultáneas
let isRedirecting = false

// Interceptor GLOBAL de axios: detecta 401/403 en CUALQUIER llamada
// y redirige al login limpiando la sesión
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status
    // Excluir las rutas de autenticación y validación para no generar loop
    const requestUrl = error?.config?.url || ''
    const isExcludedRoute = requestUrl.includes('/authorize') || 
                        requestUrl.includes('/csrf-token') || 
                        requestUrl.includes('/create-token') ||
                        requestUrl.includes('/getcoockies') ||
                        requestUrl.includes('/studio/user/')

    // Para 401: siempre redirigir (autenticación faltante)
    // Para 403: solo redirigir si el mensaje del backend indica expiración/invalidez de token,
    //           no por errores de CSRF, permisos u otras razones de negocio
    const responseMessage = error?.response?.data?.message || ''
    const isTokenError = status === 401 ||
      (status === 403 && (
        responseMessage.toLowerCase().includes('token') ||
        responseMessage.toLowerCase().includes('expired') ||
        responseMessage.toLowerCase().includes('unauthorized')
      ))

    if (isTokenError && !isRedirecting && !isExcludedRoute) {
      isRedirecting = true
      localStorage.clear()
      sessionStorage.clear()
      window.location.href = '/'
      setTimeout(() => { isRedirecting = false }, 3000)
    }

    return Promise.reject(error)
  }
)

export const ValidProvider = ({ children }) => {
  const [isValid, setIsValid] = useState(false)
  const [isInValidation, setIsInValidation] = useState(false)
  // Indica si ya terminó la validación inicial de sesión.
  // Evita redirecciones a "/" durante la fase asíncrona de validación
  // (que provocaba perder la ruta actual al refrescar la página, p.ej. en Settings).
  const [isAuthChecked, setIsAuthChecked] = useState(false)
  const validatedUser = async () => {
    let token = localStorage.getItem('hashUser') != null
      ? unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
      : undefined;
  
    let id = localStorage.getItem('hashUser') != null
      ? unfolder(localStorage.getItem('hashUser'), 'IANestingKey').id
      : undefined;

    let iduser = localStorage.getItem('hashInfo') != null
      ? unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
      : undefined;

    const restTokenCk = await axios.get(`${urlValue}/getcoockies/hashUser`,{withCredentials: true}).catch(() => ({ data: null }));
     
     let idck = "";
     if(restTokenCk.data){ 
      idck = restTokenCk.data.ck;
     }
    

    // if (iduser?.toString() !== idck?.toString() ) {
    //   localStorage.clear()
    //   setIsValid(false)
    // } else {

      if (id == undefined || token == undefined) {
        localStorage.clear()
        setIsValid(false)
        setIsAuthChecked(true)
      } else if (isInValidation == true || isValid == false) {
        axios({
          method: 'get',
          url: `${urlValue}/studio/user/${id}`,
          headers: {
            'access-token': token,
          },
        })
          .then(function (response) {
            setIsValid(true)
          })
          .catch(function (error) {
            localStorage.clear()
            setIsValid(false)
          })
          .finally(function () {
            setIsAuthChecked(true)
          })
      } else {
        setIsAuthChecked(true)
      }
    // }
    setIsInValidation(false)
  }
  useEffect(() => {
    validatedUser();
  }, [isInValidation])

  return (
    <validContext.Provider
      value={[isValid, setIsValid, isInValidation, setIsInValidation, fileSecurity, isAuthChecked]}
    >
      {children}
    </validContext.Provider>
  )
}
